import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  DatatableStudentActivityHistory,
  Student,
} from "../model/student.model";
import { NewGiveCourse, ParentCourse } from "../model/parent-course.model";

@Injectable({ providedIn: "root" })
export class ParentCourseService {
  #http = inject(HttpClient);
  private excepted_key_names: string[] = [];
  private apiParentCourseUrl = "/parent_courses";
  _setFilter(obj: any) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v != null)
    );
  }

  _setParams(value: any) {
    if (!value) return;
    const filter: any = this._setFilter(value);
    let params = new HttpParams();
    for (const key in filter) {
      if (Array.isArray(filter[key])) {
        params = params.append(key, JSON.stringify(filter[key]));
      } else {
        params = params.append(key, filter[key]);
      }
    }
    return params;
  }
  _setFormData(object_key: string, value: any) {
    let formData = new FormData();
    for (const key in value) {
      let obj = value[key];
      if (Array.isArray(obj)) {
        obj.forEach((e, i) => {
          if (this.excepted_key_names.includes(key)) {
            formData.append(`${object_key}[${key}][]`, e);
          } else {
            for (const key_i in e) {
              formData.append(`${object_key}[${key}][][${key_i}]`, e[key_i]);
            }
          }
        });
      } else {
        if (value[key]) {
          formData.append(`${object_key}[${key}]`, value[key]);
        }
      }
    }
    return formData;
  }

  //-------------------------------------------------------///

  getParentCourses(
    params?: any
  ): Observable<DatatableStudentActivityHistory[]> {
    const queryParams = this._setParams(params) || "";
    return this.#http.get<DatatableStudentActivityHistory[]>(
      `${this.apiParentCourseUrl}?${queryParams}`
    );
  }

  getAssignCourses(
    params?: any
  ): Observable<DatatableStudentActivityHistory[]> {
    const queryParams = this._setParams(params) || "";
    return this.#http.get<DatatableStudentActivityHistory[]>(
      `${this.apiParentCourseUrl}/student?${queryParams}`
    );
  }

  assignCourse(payload: NewGiveCourse): Observable<any> {
    return this.#http.post<any>("/give_courses", {
      give_course: payload,
    });
  }

  cancelAssign(id: number): Observable<ParentCourse> {
    return this.#http.delete<ParentCourse>(
      `${this.apiParentCourseUrl}/cancel_give/${id}`
    );
  }

  checkNoCourse(course_id?: number): Observable<Student[]> {
    return this.#http.get<Student[]>(`/students/no_course/${course_id}`);
  }
  checkHaveCourse(params?: any): Observable<ParentCourse> {
    const queryParams = this._setParams(params) || "";
    return this.#http.get<ParentCourse>(`/students/have_course?${queryParams}`);
  }
}

//-------------------------------------------------------///
